import { graphql } from "../gql";

graphql(`
  fragment LifecycleRoleFields on LifecycleRole {
    id
    insurerId
    name
    description
    version
    isDeleted
    createdAt
    updatedAt
  }
`);
graphql(`
  fragment LifecycleMatrixFields on RolePermissionMatrix {
    roleId
    insurerId
    version
    phases {
      phaseId
      phaseSlug
      phaseName
      allStagesGranted
      actionStates {
        action
        allStagesGranted
      }
      stages {
        stageId
        stageSlug
        stageName
        grants {
          action
          granted
        }
      }
    }
  }
`);
export const getLifecycleRolesDoc = graphql(`
  query GetLifecycleRoles($insurerId: UUID) {
    lifecycleRoles(insurerId: $insurerId) {
      ...LifecycleRoleFields
    }
  }
`);
export const getRolePermissionMatrixDoc = graphql(`
  query GetRolePermissionMatrix($roleId: UUID!) {
    rolePermissionMatrix(roleId: $roleId) {
      ...LifecycleMatrixFields
    }
  }
`);
export const createLifecycleRoleDoc = graphql(`
  mutation CreateLifecycleRole($input: CreateLifecycleRoleInput!) {
    createLifecycleRole(input: $input) {
      ...LifecycleRoleFields
    }
  }
`);
export const duplicateLifecycleRoleDoc = graphql(`
  mutation DuplicateLifecycleRole($input: DuplicateLifecycleRoleInput!) {
    duplicateLifecycleRole(input: $input) {
      ...LifecycleRoleFields
    }
  }
`);
export const updateLifecycleRoleDoc = graphql(`
  mutation UpdateLifecycleRole($input: UpdateLifecycleRoleInput!) {
    updateLifecycleRole(input: $input) {
      ...LifecycleRoleFields
    }
  }
`);
export const deleteLifecycleRoleDoc = graphql(`
  mutation DeleteLifecycleRole($input: DeleteLifecycleRoleInput!) {
    deleteLifecycleRole(input: $input) {
      ...LifecycleRoleFields
    }
  }
`);
export const saveRolePermissionMatrixDoc = graphql(`
  mutation SaveRolePermissionMatrix($input: SaveRolePermissionMatrixInput!) {
    saveRolePermissionMatrix(input: $input) {
      ...LifecycleMatrixFields
    }
  }
`);
